import LayoutWithSidebar from "../components/LayoutWithSidebar";
import AdminSettingsSideMenu from "../components/AdminSettingsSideMenu";
import AdminPermitBlueprintsListContainer from "../containers/AdminPermitBlueprintsListContainer";
import MainHeaderContainer from "../containers/MainHeaderContainer";

const AdminPermitBlueprintPage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return <AdminSettingsSideMenu></AdminSettingsSideMenu>;
  };

  const contentPanelContent = () => {
    return <AdminPermitBlueprintsListContainer></AdminPermitBlueprintsListContainer>;
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default AdminPermitBlueprintPage;

